






































































import { Component } from 'vue-property-decorator';
import authModule from '@/store/modules/common/auth.module';
import Mixin from '@/mixin';
import { validationMixin } from 'vuelidate';
import { minLength, required, email } from 'vuelidate/lib/validators';
import authService from '@/services/common/auth.service';
import VMessage from '@/components/items/VMessage.vue';
import transitionModule from '@/store/modules/common/transition.module';
import { TransitionType } from '@/config/enum';
import VPasswordInput from '@/components/items/VPasswordInput.vue';

@Component({
  name: 'login',
  components: { VPasswordInput, VMessage },
  mixins: [validationMixin],
  validations: {
    username: { required, email },
    password: { required, minLength: minLength(5) }
  }
})
export default class Login extends Mixin {
  // TODO: for testing only
  public username = process.env.VUE_APP_DEFAULT_TEST_USERNAME || '';
  public password = process.env.VUE_APP_DEFAULT_TEST_PASSWORD || '';

  get allowSubmit() {
    return !(this.$v?.$error || this.$v?.$invalid);
  }

  public async login(event: Event) {
    event.preventDefault();
    this.$v?.$touch();
    if (this.allowSubmit) {
      const authentication = await authService.login({
        email: this.username,
        password: this.password,
        devicePlatForm: process.env.VUE_APP_CLIENT_DEVICEPLATFORM || '',
        clientVersion: process.env.VUE_APP_CLIENT_VERSION || ''
      });
      if (authentication) {
        authModule.setAuthentication(authentication).then(() => this.goHome());
      }
    }
  }

  public async updateTransition() {
    await transitionModule.updateMenuStatus(TransitionType.fade);
  }
}
